import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Cliente } from "../../../services/Cliente";
import { useContextSite } from "../../../context/Context";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { IVincularClienteForm } from "../../../types/agendamento";
import { RecursosEnum } from "../../../enums/recusos";

interface IClienteId {
  uuid: string;
}

export const useDispatcherCustomer = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const { setIsLoad } = useContextSite();
  const [cliente] = useSessionStorage("@usuarioMapa");

  const { control, handleSubmit } = useForm<IClienteId>({
    defaultValues: {
      uuid: "",
    },
  });

  const getValues = async (txt: string) => {
    return Cliente.lista({ nomeCpfCnpj: txt, page: 0, size: 5 }).then(
      ({ data }) =>
        data.content.map((item) => ({
          value: item.uuid,
          label: `${item.nome} - CPF/CNPJ: ${item.cpfCnpj}`,
          element: item,
        }))
    );
  };

  function submitForm(data: IClienteId) {
    setIsLoad(true);

    const isAtendente = cliente?.recursos?.includes(
      RecursosEnum.AGENDAMENTO_ITINERANTE
    );

    const PAYLOAD: IVincularClienteForm = {
      uuid: uuidAgendamento,
      uuidCliente: data.uuid,
      uuidDespachanteResponsavel: isAtendente ? "" : cliente?.uuidCliente,
    };

    Agendamento.vincularAgendamentoAoCliente(PAYLOAD)
      .then(() => {
        navigate(
          `/agendamento/${uuidAgendamento}/despachante-cliente/detalhe-cliente?id=${data.uuid}`
        );
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  return {
    navigate,
    Controller,
    control,
    handleSubmit,
    submitForm,
    getValues,
    uuidAgendamento,
  };
};
